import { Link, useLocation } from 'react-router-dom';
import { cn } from '@/lib/utils';
import { POLICY_SECTIONS, sectionUrl } from '../sections';

/** The four section links, styled as tabs; the current one is underlined and carries aria-current. */
export function SectionNav({ policyId }: { policyId: string }) {
  const { pathname } = useLocation();
  const here = pathname.replace(/\/$/, '');
  return (
    <nav aria-label="Policy sections" className="flex gap-1 overflow-x-auto">
      {POLICY_SECTIONS.map(({ section, label, path }) => {
        const to = sectionUrl(policyId, path);
        const current = here === to;
        return (
          <Link
            key={section}
            to={to}
            aria-current={current ? 'page' : undefined}
            className={cn(
              'border-b-2 px-3 py-2.5 text-sm',
              current ? 'border-primary font-semibold text-foreground' : 'border-transparent text-muted-foreground'
            )}
          >
            {label}
          </Link>
        );
      })}
    </nav>
  );
}
